import { IconV2 } from 'components/common/IconV2/IconV2';
import type { SmallIconV2Props } from 'components/common/IconV2/IconV2.types';

const ErrorFilledSmallIcon = (props: SmallIconV2Props) => (
  <IconV2 {...props} viewBox="0 0 16 16">
    <mask id="icon__path-1-inside-1_11923_1749" fill="#fff">
      <path
        fillRule="evenodd"
        d="M15 8A7 7 0 1 1 1 8a7 7 0 0 1 14 0m-7.7 2.55a.7.7 0 1 1 1.4 0 .7.7 0 0 1-1.4 0m.1-2.3a.6.6 0 1 0 1.2 0V5a.6.6 0 0 0-1.2 0z"
        clipRule="evenodd"
      />
    </mask>
    <path
      fill="currentcolor"
      fillRule="evenodd"
      d="M15 8A7 7 0 1 1 1 8a7 7 0 0 1 14 0m-7.7 2.55a.7.7 0 1 1 1.4 0 .7.7 0 0 1-1.4 0m.1-2.3a.6.6 0 1 0 1.2 0V5a.6.6 0 0 0-1.2 0z"
      clipRule="evenodd"
    />
    <path
      fill="currentcolor"
      d="M8.6 8.25h-1zM8.6 5h1zM8 16a8 8 0 0 0 8-8h-2a6 6 0 0 1-6 6zM0 8a8 8 0 0 0 8 8v-2a6 6 0 0 1-6-6zm8-8a8 8 0 0 0-8 8h2a6 6 0 0 1 6-6zm8 8a8 8 0 0 0-8-8v2a6 6 0 0 1 6 6zm-8 .85a1.7 1.7 0 0 0-1.7 1.7h2a.3.3 0 0 1-.3.3zm1.7 1.7A1.7 1.7 0 0 0 8 8.85v2a.3.3 0 0 1-.3-.3zM8 12.25a1.7 1.7 0 0 0 1.7-1.7h-2a.3.3 0 0 1 .3-.3zm-1.7-1.7a1.7 1.7 0 0 0 1.7 1.7v-2a.3.3 0 0 1 .3.3zM8 7.85c.221 0 .4.18.4.4h-2A1.6 1.6 0 0 0 8 9.85zm-.4.4c0-.22.18-.4.4-.4v2a1.6 1.6 0 0 0 1.6-1.6zM7.6 5v3.25h2V5zm.4.4a.4.4 0 0 1-.4-.4h2A1.6 1.6 0 0 0 8 3.4zm.4-.4a.4.4 0 0 1-.4.4v-2A1.6 1.6 0 0 0 6.4 5zm0 3.25V5h-2v3.25z"
      mask="url(#icon__path-1-inside-1_11923_1749)"
    />
  </IconV2>
);

export default ErrorFilledSmallIcon;
